import { createStore, applyMiddleware, compose } from "redux"
import createSagaMiddleware from "redux-saga"
import { createBrowserRouter, createRoutesFromElements } from "react-router-dom"
import sagas from "./sagas"
import reducers from "./reducers"
import { createQueryStringStoreMiddleware } from "./new/redux-middlewares/query-string"
import actionCreator from "helpers/actionCreator"
import getRoutes from "./routes"

export default function configureApp(initialState, DevTools) {
  // Router
  const routes = createRoutesFromElements(getRoutes())
  const router = createBrowserRouter(routes)

  // Saga
  const sagaMiddleware = createSagaMiddleware()
  sagaMiddleware.setContext({
    router,
  })

  let enhancer = applyMiddleware(sagaMiddleware, createQueryStringStoreMiddleware(router.navigate))
  if (DevTools.instrument) {
    const reduxDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

    enhancer = compose(
      enhancer,
      reduxDevToolsExtension ? reduxDevToolsExtension({
        actionCreators: actionCreator,
        trace: true,
        traceLimit: 25,
        serialize: true,
      }) : DevTools.instrument(),
    )
  }

  const store = createStore(
    reducers,
    initialState,
    enhancer,
  )

  sagas.forEach(saga => sagaMiddleware.run(saga))

  return { store, router }
}
